/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionType } from './ConditionType';
import {
    ConditionTypeFromJSON,
    ConditionTypeFromJSONTyped,
    ConditionTypeToJSON,
    ConditionTypeToJSONTyped,
} from './ConditionType';

/**
 * 
 * @export
 * @interface ConditionResponse
 */
export interface ConditionResponse {
    /**
     * 
     * @type {ConditionType}
     * @memberof ConditionResponse
     */
    type: ConditionType;
    /**
     * Confidence score for the detected value
     * @type {number}
     * @memberof ConditionResponse
     */
    minScore?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionResponse
     */
    match?: Array<string>;
}



/**
 * Check if a given object implements the ConditionResponse interface.
 */
export function instanceOfConditionResponse(value: object): value is ConditionResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ConditionResponseFromJSON(json: any): ConditionResponse {
    return ConditionResponseFromJSONTyped(json, false);
}

export function ConditionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': ConditionTypeFromJSON(json['type']),
        'minScore': json['minScore'] == null ? undefined : json['minScore'],
        'match': json['match'] == null ? undefined : json['match'],
    };
}

export function ConditionResponseToJSON(json: any): ConditionResponse {
    return ConditionResponseToJSONTyped(json, false);
}

export function ConditionResponseToJSONTyped(value?: ConditionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': ConditionTypeToJSON(value['type']),
        'minScore': value['minScore'],
        'match': value['match'],
    };
}

